function AddProductToCart(productsArr, $this){
  if($this != null){
    $this.addClass("active");
  }

  document.dispatchEvent(new Event("gOpenCart"));

  let formData = {
    'items': productsArr
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'xmlhttprequest'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(res => {
    if(res.status){
      console.log(res);
    }
    else{
      //window.upcartOpenCart();
      // ✅ Item added, now refresh cart contents
      const cartDrawer = document.querySelector('tcc-cart-drawer');
      if(cartDrawer) {
        cartDrawer.refreshCart();
        cartDrawer.checkFreeProduct();
      }
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(() => {
    if($this != null){
      $this.removeClass("active");
    }
  });
}
$(document).on("click", ".new-main-product-atc-btn", function(e){
  e.preventDefault();
  e.stopPropagation();
  let arr = [];
  arr.push({ 'id': $(this).attr("data-id"), 'quantity': 1 });
  if($(".new-main-product-addons-inp:checked").length > 0){
    $(".new-main-product-addons-inp:checked").each(function(){
      arr.push({ 'id': $(this).val(), 'quantity': 1 });
    })
  }
  AddProductToCart(arr, $(this));
})
$(document).on("change", ".new-main-product-variants-inp", function(){
    $(".new-main-product-variants-title span").text($(this).attr("data-title"));
    let img = $(this).attr("data-img");
    if($(`.new-main-product-swiper-slide[data-img="${img}"]`).length > 0){
      let index = $(`.new-main-product-swiper-slide[data-img="${img}"]`).attr("data-index");
      $(".new-main-product-swiper")[0].swiper.slideTo(index);
    }
    if($(".new-main-product-price").length > 0){
      $(".new-main-product-price").html($(this).attr("data-price"));
    }
    let badge = $(this).attr("data-badge");
    if($(".new-main-product-save").length > 0){
      $(".new-main-product-save").removeClass("active");
      if(badge != "none"){
        $(".new-main-product-save").text(badge);
        $(".new-main-product-save").addClass("active");
      }
    }
    $(".new-main-product-atc-btn").attr("data-id", $(this).val());
    let iq = $(this).attr("data-sold").trim();
    if(iq == "sold"){
      $(".new-main-product-atc-btn").addClass("sold");
    }
    else{
      $(".new-main-product-atc-btn").removeClass("sold");
    }
})
$(document).on("click", ".new-main-product-addons-img", function(e){
  let id = $(this).attr("data-id");
  $(`.new-main-product-addons-image-wrapper`).removeClass("active");
  if($(`.new-main-product-addons-image-wrapper[data-id="${id}"]`).length > 0){
    $(`.new-main-product-addons-image-wrapper[data-id="${id}"]`).addClass("active");
  }
})
$(document).on("click", ".new-main-product-addons-image-swiper", function(e){
  e.stopPropagation();
  e.preventDefault();
})
$(document).on("click", ".new-main-product-addons-image-wrapper", function(e){
  $(`.new-main-product-addons-image-wrapper`).removeClass("active");
})
$(document).on("click", ".new-main-product-rating .jdgm-widget", function(){
  if($("#judgeme_product_reviews").length > 0){
    $('html, body').animate({scrollTop: parseInt($("#judgeme_product_reviews").offset().top)}, 500);
  }
})
$(document).on("click", ".new-main-product-meta-tab", function(e){
  $(".new-main-product-meta-tab").removeClass("active");
  $(this).addClass("active");
  let title = $(this).text().trim();
  $(".new-main-product-meta-body").removeClass("active");
  if($(`.new-main-product-meta-body[data-title="${title}"]`).length > 0){
    $(`.new-main-product-meta-body[data-title="${title}"]`).addClass("active");
    let activeText = $(".new-main-product-meta-heading span").text().trim();
    if($(`.new-main-product-meta-body[data-title="${title}"] .new-main-product-meta-prod-title[data-title="${activeText}"]`).length > 0){
      location.href = $(`.new-main-product-meta-body[data-title="${title}"] .new-main-product-meta-prod-title[data-title="${activeText}"]`).attr("href");
    }
  }
});